"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetPageQuickLinks = void 0;
exports.SetPageQuickLinks = [
    'calendar',
    'chat',
    'education',
    'heart',
    'home',
    'image',
    'music',
    'newspaper',
    'phone',
    'rocket',
    'sms',
    'tshirt',
    'user',
    'video'
];
//# sourceMappingURL=QuickLinks.js.map